import JsonApiObject from '@/_models/JsonApi'
import User from '@/views/User/models/user'

export default class TextHistoryItemModel extends JsonApiObject {
    public constructor(data: any, included?) {
        super(data, included)
    }

    time
    text
    principalTranslationJobName

    get principalUser(): User {
        return this._relationships['principalUser'] ? this._relationships['principalUser'] : null
    }
}
